/**
 *
 */
export enum OtherNodeLabel {
    GENERAL_LOAD = "General Load",
    LIGHTING  = "Lighting",
}